export default __webpack_public_path__ + "cover.e71c53df8abbf1a9954e363638dcca70.jpg"